import React from 'react'
import Grid from '@cloudscape-design/components-themed/grid'

// https://cloudscape.design/components/grid
export function RadGrid ({ ...rest }) {
  return (
    <Grid {...rest} />
  )
}
